export const CHECKLIST_TOAST_SCOPE = 'checklist';
